var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-7"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{attrs:{"src":require(`@/assets/images/magnifying-glass.svg`)}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"empty-states-msg1 font-weight-semibold font-xl"},[_vm._v("No results found for the selected filters 😐")])])
}]

export { render, staticRenderFns }